import React from 'react';
import ReactTable from "react-table";
import { TableConfig } from '../../utils/appConfig';
import Pagination from '../page/Pagination';
import NoData from '../page/NoData';
import Logger, { LOG_LEVELS } from '../../utils/logger';

const log = new Logger('BULK_TRANSACTION_ERROR_DETAILS', LOG_LEVELS.DEBUG);

const NoDataComponent = props => (
    <NoData
        noDataText="No Failed Entities"
        {...props}
    />
);

const BulkTransactionErrorDetails = ({ operation }) => {
    log.debug('Rendering BulkTransactionErrorDetails', operation);

    if (!operation?.entities) {
        return null;
    }
    
    // Transform failed entities into table data
    const failedEntitiesData = operation.entities
        .filter(entity => entity.status === "Failed")
        .map(entity => ({
            entityId: entity.entityId,
            error: entity.reason || 'Unknown error'
        }));

    if (failedEntitiesData.length === 0) {
        return null;
    }

    // Table columns configuration
    const columns = [
        {
            Header: 'Id',
            accessor: 'entityId',
            minWidth: 300
        },
        {
            Header: 'Reason',
            accessor: 'error',
            minWidth: 600
        }
    ];

    return (
        <div className="failed-entities-table mt10">
            <ReactTable
                data={failedEntitiesData}
                columns={columns}
                defaultPageSize={TableConfig.PAGINATION.STANDARD_LEVEL_TWO_PAGE_SIZE}
                minRows={Math.min(failedEntitiesData.length, TableConfig.PAGINATION.STANDARD_LEVEL_TWO_PAGE_SIZE)}
                showPagination={failedEntitiesData.length > TableConfig.PAGINATION.STANDARD_LEVEL_TWO_PAGE_SIZE}
                PaginationComponent={Pagination}
                showPageJump={true}
                pageSizeOptions={TableConfig.PAGINATION.STANDARD_PAGE_SIZE_OPTIONS}
                noDataText=""
                NoDataComponent={NoDataComponent}
                className="-striped -highlight"
            />
        </div>
    );
};


export default BulkTransactionErrorDetails;